import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicModePaiement = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Wodzone accepte plusieurs modes de paiement en fonction du pays de domiciliation de votre compte bancaire. 
              Grâce à notre partenariat avec Stripe, nous vous garantissons des paiements sécurisés
            </p>
            <p className="help-text">
              Les modes de paiement disponibles s'affichent sur la page de paiement.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <ul>
                <li className="pl-8 mb-8"><p className="help-text">Visa, Mastercard, American Express, Discover, Diners Club, JCB et China UnionPay dans le monde entier.</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Apple Pay</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Google Pay</p></li>
              </ul>
              <p className="help-text mt-24">
                Les paiements en espèces ou effectués en dehors du site vont à l'encontre de nos
                <a target='_blank' className="link" href="#">Conditions de service</a>et 
                peuvent conduire à une exclusion de la communauté Wodzone.
                <a target='_blank' className="link" href="#">Lorsque vous payez en dehors de la plateforme,</a>
                il nous est plus difficile de protéger vos données et vous vous exposez à un risque accru de fraudes et de 
                failles de sécurité.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicModePaiement